import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map, Pane, TileLayer, GeoJSON } from 'react-leaflet';
import ReactLoading from 'react-loading';
import ReactModal from 'react-modal';
// import * as chroma from 'chroma-js';
import { fetchPublicData, viewpointChange, clearErrorMessage } from '../../actions/public';
import { hideNav, showNav } from '../../actions';
import 'leaflet/dist/leaflet.css';
import '../../css/map.css';
import '../../css/public.css';


const customStyles = {
  overlay: {
    zIndex                : '10000000'
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

ReactModal.setAppElement('#root');

class PublicMapViewComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      modalMessage: '',
      tooltips: true,
      draggable:true
    }
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.errorMessage) {
      this.setState({modalMessage: nextProps.errorMessage });
      this.setState({modalIsOpen: true});
    }
  }

  componentWillMount() {
    this.props.dispatch(hideNav());
    if(this.props.fields_crops.size === 0) {
      this.props.dispatch(fetchPublicData());
    }
  }

  componentWillUnmount() {
      this.props.dispatch(showNav());
   }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    this.subtitle.style.color = '#222';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
    this.props.dispatch(clearErrorMessage())
  }

  toggleTooltips() {
    this.setState({ tooltips: !this.state.tooltips })
  }

  viewpointChanged(viewpoint){
    this.props.dispatch(viewpointChange(viewpoint));
  }

  render() {

    var isBusy = this.props.isBusy;
    
    //const fieldCrops = ['Cattle / Cattle Forage Crop', 'Row Crops (Kale/Onion etc.)', 'Community Farm', 'Citrus', 'Papaya / Tropical Fruit', 'Avocado', 'Macadamia Nut', 'Coffee']
    //const fieldCrops = ['Row Crops (Kale/Onion etc.)', 'Community Farm', 'Avocado', 'Cattle / Cattle Forage Crop', 'Macadamia Nut', 'Citrus', 'Papaya / Tropical Fruit', 'Coffee']
    const fieldCrops = ['Row Crops', 'Community Farm', 'Avocado', 'Cattle / Cattle Forage Crop', 'Macadamia Nut', 'Citrus', 'Tropical Fruit', 'Coffee']
    //const fieldCrops = ['Row Crops (Potato/Onion etc.)', 'Community Farm', 'Avocado', 'Cattle / Cattle Forage Crop', 'Macadamia Nut', 'Citrus', 'Papaya / Tropical Fruit', 'Coffee']
    //const fieldColors = chroma.scale(['#3d5c00','#51712C','#6e8b0c','#c7af00','#f4d322','#b4a245']).mode('lch').colors(fieldCrops.length);
    const fieldColors = ['#1f4408','#3d5c00','#51712C','#6e8b0c','#c7af00','#f4d322','#e0a038','#604f0a'];
    
    function style_fields_crops (feature) {
      return {
        color: '#646466',
        // opacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.3) : 0.5,
        opacity: 1,
        fillColor: feature.properties.Crop ? fieldColors[fieldCrops.indexOf(feature.properties.Crop)] : '#ffffff',
        // fillOpacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.4) : 0.5,
        fillOpacity: 1,
        weight: 0.8
      };
    }

    function onEveryFeatureFieldsCrops(feature, layer){
      // let planted = feature.properties.Planted === 'Y' ? 'Planted' : 'Future Crop';
      if (feature.properties.Field) {
        // layer.bindPopup('<b>Field ' + feature.properties.Field + '</b></br>' + feature.properties.Crop + '</br>' + planted )
        layer.bindPopup('<b>Field ' + feature.properties.Field + '</b></br>' + (feature.properties.Crop_Label ? feature.properties.Crop_Label : '--') + '</br>' + (feature.properties.Status ? feature.properties.Status : '--') )
        .bindTooltip(feature.properties.Field, { permanent: true, direction: 'center', className: "my-label field-label", offset: [0, 0] })
      }

      layer.on('mouseover', function (e) {
        this.openPopup(e.latlng);
      });
      layer.on('mouseout', function (e) {
        this.closePopup();
      });
    }

    var fields_crops = undefined;
    if(this.props.fields_crops.size > 0) {
      fields_crops = (<GeoJSON key={1} data={this.props.fields_crops.toJSON()} onEachFeature={onEveryFeatureFieldsCrops} style={style_fields_crops}></GeoJSON>);
    }

    return (
      <div className="mapApp map_container" style={{height: this.props.template.height, width: this.props.template.width }}>
        <ReactModal isOpen={this.state.modalIsOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.closeModal} style={customStyles} contentLabel="Query Name Modal">
          <h4 ref={subtitle => this.subtitle = subtitle}>{this.state.modalMessage}</h4>
          <button className="btn btn-info center-block" onClick={this.closeModal}>Okay</button>
        </ReactModal>
        {isBusy ? (
          <div style={{marginTop: (this.props.height * 0.25), marginLeft: (this.props.width * 0.25), zIndex:1000000, width:'25%', height:'25%', backgroundColor:'rgba(255,255,255,0.0)', position:'absolute'}}>
            <ReactLoading type='bubbles' color='#333333' height='25%' width='50%' className='center-loader' />
          </div>) : (
          <div></div>
         )}
         <Map ref="public_map" center={this.props.mapCenter} zoom={this.props.mapZoom} onViewportChanged={this.viewpointChanged.bind(this)} zoomControl={true} minZoom={11} maxZoom={14}>
           <TileLayer
             url='https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
             attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
           />
          <Pane name="leaflet-properties-overlay-pane" style={{ zIndex: 300 }}>
            { fields_crops ? (fields_crops) : null }
          </Pane>
        </Map>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fields_crops: state.PublicApp.get('fields_crops'),
    // rawParcels: state.PublicApp.get('parcels'),
    // parcels: state.PublicApp.get('modifiedParcels'),
    mapCenter: state.PublicApp.get('mapCenter'),
    mapZoom: state.PublicApp.get('mapZoom'),
    mapBounds: state.PublicApp.get('mapBounds'),
    draggable: state.PublicApp.get('draggable'),
    errorMessage: state.PublicApp.get('errorMessage'),
    template: state.Template,
    isBusy: state.isBusy
  }
}

const PublicMapView = connect(mapStateToProps)(PublicMapViewComp)

export default PublicMapView;



// WEBPACK FOOTER //
// ./src/components/PublicView/index.js